module.exports = require('crypto');


//////////////////
// WEBPACK FOOTER
// ./~/randomhex/src/crypto.js
// module id = 653
// module chunks = 0